import Vue from 'vue'
import Router from 'vue-router'

import indexView from '@/pages/dcpdetail/enter'
import listView from '@/pages/dcpdetail/reference/dcplist'
import detailView from '@/pages/dcpdetail/reference/dcpdetail'

import oldView from '@/components/SamplePage'
import uploadView from '@/pages/uploadpage'
// import originUpload from '@/pages/originUpload'

import bulistView from '@/pages/bulist'
import projectlist from '@/pages/projectlist'
import projectdcplist from '@/pages/projectdcplist'
import dcpdatalistView from '@/pages/dcpdatalist'

Vue.use(Router)

  let oldRoutes = {
    name: 'index',
    path: '/',
    component: oldView,
    meta: {
        keepAlive: true
    }
  }
  let indexRoutes = {
    name: 'index',
    path: '/v2/',
    component: indexView,
    meta: {
        keepAlive: true
    }
  }
  
  let listRoute = {
    name: 'dcplist',
    path: '/v2/dcplist',
    component: listView,
    meta: {
        keepAlive: true
    }
  }
  let detailRoute = {
    name: 'dcpdetail',
    path: '/v2/dcpdetail',
    component: detailView,
    meta: {
        keepAlive: true
    }
  }

  let bulistRoute = {
    name: 'bulistview',
    path: '/bulist',
    component: bulistView,
    meta: {
        keepAlive: true
    }
  }

  let projectlistRoute = {
    name: 'projectList',
    path: '/projectlist',
    component: projectlist,
    meta: {
        keepAlive: true
    }
  }

  let projectdcplistRoute = {
    name: 'projectDcpList',
    path: '/projectdcplist',
    component: projectdcplist,
    meta: {
        keepAlive: true
    }
  }

  let dcpdatalistRoute = {
    
    name: 'dcpdatalist',
    path: '/dcpdatalist',
    component: dcpdatalistView,
    meta: {
        keepAlive: true
    }
  }

  let originUploadRoute = {
    name: 'originUpload',
    path: '/v3/',
    component: bulistView,
    meta: {
      keepAlive: true
    }
  }

  // let bulistTestRoute = {
  //   name: 'bulistTestRoute',
  //   path: '/bulist',
  //   component: uploadView,
  //   meta: {
  //     keepAlive: true
  //   }
  // }

let router = new Router({
    mode: 'history',
    saveScrollPosition: true,
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
          return { x: 0, y: 0 }
      }
    },
    routes: [
      oldRoutes,
      indexRoutes,
      listRoute,
      detailRoute,
      originUploadRoute,
      bulistRoute,
      projectlistRoute,
      projectdcplistRoute,
      dcpdatalistRoute
    ]
  })


export default router